<ngx-intl-tel-input
  [cssClass]="'custom'"
  [preferredCountries]="preferredCountries"
  [enableAutoCountrySelect]="true"
  [enablePlaceholder]="true"
  [searchCountryFlag]="true"
  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
  [selectFirstCountry]="false"
  [selectedCountryISO]="selectedCountryISO"
  [maxLength]="15"
  [phoneValidation]="true"
  [separateDialCode]="false"
  [numberFormat]="PhoneNumberFormat.National"
  name="phone"
  [(ngModel)]="model"
  [customPlaceholder]="customPlaceholder"
  [inputId]="inputId"
  (ngModelChange)="onModelChange($event)"
  (countryChange)="onCountryChange($event)">
</ngx-intl-tel-input>
